<template>  
  <div>
  <q-card inline style="width: 300px; background-color: transparent">
  <q-card-section class="text-h6">
    {{$t('global.ProcessAlerts')}}
  </q-card-section>
  <q-card-main>
    <div class="row">
      <div class="col-5 leftSide">
        {{$t('global.DateTime')}}:
      </div>
      &nbsp;
      <div class="col rightSide">
        {{dateFormat(Entity.AlertDateTime)}}
      </div>
    </div> 
    <div class="row">
      <div class="col-5 leftSide">
        {{$t('global.Type')}}:
      </div>
      &nbsp;
      <div class="col rightSide">
        {{Entity.AlertConfigDetailTypeDescription}}
      </div>
    </div> 
    <div class="row">
      <div class="col-5 leftSide">
        {{$t('global.GeofenceName')}}:
      </div>
      &nbsp;
      <div class="col rightSide">
        {{Entity.GeofenceName}}
      </div>
    </div> 
    <div class="row">
      <div class="col-5 leftSide">
        Alert:
      </div>
      &nbsp;
      <div class="col rightSide">
        {{Entity.AlertConfigName}}
      </div>
    </div>  

    <div class="row">
      <div class="col-5 leftSide">
       Unit:
      </div>
      &nbsp;
      <div class="col rightSide">
       {{Entity.DeviceName}}
      </div>
    </div>  

    
    <div class="row content">
      <div class="col-12">
       <q-input
          v-model="comment"
          type="textarea"
          :label="$t('global.Comment')"
          autogrow
        />
      </div>  
    </div> 
    
    

    <div class="row content">
      <div class="col-12">
        <br>
        <q-btn color="primary"  
        :label="$t('global.SaveCommentMarkLoad')" 
        @click="alertProcess(false)" 
        :no-caps="true"
        />
      </div>
      <div class="col-12">
        <br>
        <q-btn color="primary"  
        :label="$t('global.SaveCommmentMarkAll')" 
        @click="alertProcess(true)" 
        :no-caps="true"
        />
      </div>
    </div>  
  </q-card-main>
  
  <q-card-separator />
</q-card>   
  </div>
</template>

<script>
import { date } from 'quasar'
import {eventBus} from '../../main'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'ExportTrack',
  data () {
    return {
      form: {
        SessionId: null,
      },
      comment: null
    }
  },
  props: ['Entity'],
  methods: {
    dateFormat(val) {
      if (this.$i18n.locale == "de")
        return date.formatDate(val, 'DD.MM.YYYY HH:mm:ss')
      else
        return date.formatDate(val, 'MM/DD/YYYY HH:mm:ss')
    },  
    alertProcess(all){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.Comment = this.comment
      if(all == true){
        this.form.action = "MarkAllAlertsProcessed"
      }
      else{
        this.form.action = "MarkAlertProcessed"
        this.form.AlertID = this.Entity.AlertID
      }
      
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          if(response.status == 200){ 
            var newAlert = response.data
            if (newAlert != null){
              this.Entity.AlertID = newAlert.AlertID
              this.Entity.AlertDateTime = newAlert.AlertDateTime
              this.Entity.AlertConfigDetailTypeDescription = newAlert.AlertConfigDetailTypeDescription
              this.Entity.GeofenceName = newAlert.GeofenceName
              this.Entity.AlertConfigName = newAlert.AlertConfigName
              this.Entity.DeviceName = newAlert.DeviceName
              this.$q.notify({ message: this.$t('global.AlertProcessed'), type: 'positive'})
            }
            else{
              //No more alerts to process
              eventBus.$emit('loadDialog', "SideDialogWelcome")
              eventBus.$emit('closeDialog', null)
              this.$q.notify({ message: this.$t('global.AlertsProcessed'), type: 'positive'})
            }
            
            eventBus.$emit('dataLoad')
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })


    }
  },
    
  created () {
    
  },
   watch: {
    
   },
  
}

function error(err) {
  console.log(`ERROR(${err.code}): ${err.message}`);
}

</script>

<style scoped>
 .leftSide{
   text-align: right;
 }
 .rightSide{
   font-weight: 700;
 }
 .content{
   padding: 10px;
 }
</style>
